import React from "react"
import Layout from "../components/Layout/Layout"
import SEO from "../components/SEO/seo"
import Recognise from "../components/Pages/Recognise/Recognise"

const PricingPage = () => (
  <Layout>
    <SEO title="Recognise" ogTitle={'Recognise what really matters'}/>
    <Recognise/>
  </Layout>
)

export default PricingPage
